// C15 · أسئلة وأجوبة الشركة + شات (company Q&A manager + test-ask). Per-screen
// i18n namespace, merged at load time by i18n.ts's require.context('./screens').
// Full ar/en parity for every key the chatbot-qa.vue view binds.
module.exports = {
  ar: {
    'chatbot-qa': {
      title: 'أسئلة وأجوبة الشركة',
      crumb: 'الشات بوت',
      loading: 'جارٍ التحميل…',
      error: 'حدث خطأ أثناء تحميل أسئلة الشركة',
      empty: 'لا توجد أسئلة مطابقة للبحث',
      reference:
        'هذه الأسئلة خاصة بموظفيك فقط، وتُعرض قبل بنك الأدمن العام في ترتيب الرد. الإجابات العامة (تغطيات المنصة، الاسترداد…) موجودة أصلاً في بنك الأدمن.',
      addBtn: '➕ سؤال',
      listTitle: 'أسئلة شركتك',
      count: '{n} سؤال',
      searchPlaceholder: 'ابحث في أسئلة شركتك…',
      cols: {
        question: 'السؤال',
        phrasings: 'صيغ بديلة',
        status: 'الحالة',
      },
      phrasingCount: '{n} صيغة',
      status: { active: 'مفعّل', inactive: 'متوقف' },
      act: { edit: 'تعديل', activate: 'تفعيل', suspend: 'إيقاف', delete: 'حذف' },
      form: {
        createTitle: '➕ إضافة سؤال للشركة',
        editTitle: '✏️ تعديل السؤال',
        save: '💾 حفظ',
        cancel: 'إلغاء',
      },
      field: {
        question: 'السؤال',
        questionPlaceholder: 'مثلاً: من هو مسؤول الموارد البشرية الذي أتواصل معه للاسترداد؟',
        answer: 'الإجابة المعتمدة',
        answerPlaceholder: 'اكتب الإجابة الرسمية التي سيعرضها البوت',
        phrasings: 'صيغ بديلة للسؤال',
        phrasingPlaceholder: 'صيغة أخرى للسؤال…',
        addPhrasing: '+ إضافة صيغة',
        category: 'التصنيف',
        status: 'الحالة',
      },
      categories: {
        internal: 'إجراءات داخلية',
        policy: 'البوليصة',
        network: 'الشبكة',
        general: 'عام',
      },
      required: 'اكتب السؤال والإجابة المعتمدة أولاً',
      saveError: 'تعذّر حفظ السؤال، حاول مرة أخرى',
      preview: {
        title: '🧪 معاينة الرد',
        tryTag: 'تجربة',
        askPlaceholder: 'اكتب سؤالاً كما سيكتبه الموظف…',
        askBtn: 'جرّب',
        error: 'تعذّر جلب الرد، حاول مرة أخرى',
        matchedLabel: '🎯 طابق سؤال شركتك:',
        fallback: 'لا يوجد تطابق فوق العتبة — سيعرض البوت رسالة افتراضية أو يحوّل الطلب للبحث.',
        confidence: 'الثقة {n}%',
        sourceLabel: 'المصدر',
      },
      source: { company: 'أسئلة الشركة', fallback: 'لا يوجد تطابق', llm: 'مساعد Vivo الذكي' },
      orderNoteLabel: 'ترتيب الرد',
      orderNote:
        'يبحث البوت أولاً في أسئلة شركتك (C15)، ثم في بنك الأدمن العام (A20)، وإذا لم يوجد تطابق فوق العتبة يعرض رسالة افتراضية أو يحوّل الطلب للبحث.',
    },
  },
  en: {
    'chatbot-qa': {
      title: 'Company Q&A',
      crumb: 'Chatbot',
      loading: 'Loading…',
      error: 'Failed to load the company Q&A',
      empty: 'No questions match your search',
      reference:
        'These questions are for your employees only and come before the admin global bank in answer order. General answers (platform coverage, refunds…) already live in the admin bank.',
      addBtn: '➕ Question',
      listTitle: 'Your Company Questions',
      count: '{n} questions',
      searchPlaceholder: 'Search your company questions…',
      cols: {
        question: 'Question',
        phrasings: 'Alt. phrasings',
        status: 'Status',
      },
      phrasingCount: '{n} phrasings',
      status: { active: 'Active', inactive: 'Paused' },
      act: { edit: 'Edit', activate: 'Activate', suspend: 'Pause', delete: 'Delete' },
      form: {
        createTitle: '➕ Add a Company Question',
        editTitle: '✏️ Edit Question',
        save: '💾 Save',
        cancel: 'Cancel',
      },
      field: {
        question: 'Question',
        questionPlaceholder: 'e.g. Who is the HR contact for refunds?',
        answer: 'Approved answer',
        answerPlaceholder: 'Write the official answer the bot will return',
        phrasings: 'Alternate phrasings',
        phrasingPlaceholder: 'Another way to ask…',
        addPhrasing: '+ Add phrasing',
        category: 'Category',
        status: 'Status',
      },
      categories: {
        internal: 'Internal procedures',
        policy: 'Policy',
        network: 'Network',
        general: 'General',
      },
      required: 'Enter the question and the approved answer first',
      saveError: 'Could not save the question, please try again',
      preview: {
        title: '🧪 Answer Preview',
        tryTag: 'Test',
        askPlaceholder: 'Type a question the way an employee would…',
        askBtn: 'Try',
        error: 'Could not fetch the answer, please try again',
        matchedLabel: '🎯 Matched a company question:',
        fallback: 'No match above the threshold — the bot returns a default message or hands off to search.',
        confidence: 'Confidence {n}%',
        sourceLabel: 'Source',
      },
      source: { company: 'Company questions', fallback: 'No match', llm: 'Vivo AI assistant' },
      orderNoteLabel: 'Answer order',
      orderNote:
        'The bot searches your company questions first (C15), then the admin global bank (A20); with no match above the threshold it returns a default message or hands off to search.',
    },
  },
};
